<template>
    <v-flex xs12>
        <ForumMeetingTools></ForumMeetingTools>        
        <forum-quick-links></forum-quick-links>
        <about-tile v-if="canViewAboutTile" :can-view-about="canViewAbout" :can-view-chair="canViewChair" :can-view-sponsors="canViewSponsors"></about-tile>
        <filesand-media v-if="isVisible" id="files_Media_UnitTest"> </filesand-media>
    </v-flex>
</template>

<script>
    import ForumMeetingTools from '../ForumPage/ForumMeetingTools';
    import ForumQuickLinks from '../ForumPage/ForumQuickLinks';
    import AboutTile from '../ChapterPage/AboutTile/AboutTile';
    import FilesandMedia from "../ChapterPage/FilesandMedia/FilesandMedia";
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import communityLeftSideBarMixin from "../../mixins/communityLeftSideBarMixin";

    export default {
        name: 'ForumLeftSidebar',
        mixins: [communityLeftSideBarMixin],
        components: {
            ForumMeetingTools,
            ForumQuickLinks,
            AboutTile,
            FilesandMedia,
        },
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            }),
            isVisible() {
                return this.$route.params.communityId !== undefined;
            },
            // showQuickLinks() {
            //     return (this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId)) || (this.communityInfo && this.communityInfo.isAdmin);
            // },
        },
    };
</script>
